import React from 'react';
import { useNavigate } from 'react-router-dom';

function TermsAndConditions() {
    const navigate = useNavigate();

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
            color: '#f0f0f0',
            padding: '20px'
        }}>
            <div style={{
                maxWidth: '800px',
                margin: '0 auto',
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '12px',
                padding: '40px',
                border: '1px solid #404040'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '32px',
                    flexWrap: 'wrap',
                    gap: '16px'
                }}>
                    <h1 style={{
                        color: '#ff6b35',
                        margin: '0',
                        fontSize: '2.5rem',
                        fontWeight: '700'
                    }}>
                        Terms and Conditions
                    </h1>
                    <button
                        onClick={() => navigate('/login')}
                        style={{
                            background: 'rgba(255, 107, 53, 0.2)',
                            border: '1px solid #ff6b35',
                            color: '#ff6b35',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}
                    >
                        ← Back to Login
                    </button>
                </div>

                <div style={{
                    lineHeight: '1.6',
                    fontSize: '16px',
                    color: '#e0e0e0'
                }}>
                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            1. Acceptance of Terms
                        </h2>
                        <p>
                            By accessing and using the Family Budget application ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                        </p>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            2. Description of Service
                        </h2>
                        <p>
                            Family Budget is a web-based application designed to help families track expenses, manage budgets, and categorize spending. The Service allows users to:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Create and manage expense records</li>
                            <li>Organize expenses by categories</li>
                            <li>Import expense data from CSV files</li>
                            <li>Track budget limits and spending patterns</li>
                            <li>Share family budget data with family members</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            3. User Accounts and Registration
                        </h2>
                        <p>
                            To use the Service, you must register for an account by providing accurate and complete information. You are responsible for:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Maintaining the confidentiality of your account credentials</li>
                            <li>All activities that occur under your account</li>
                            <li>Notifying us immediately of any unauthorized use of your account</li>
                            <li>Ensuring your registration information remains accurate and up-to-date</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            4. Privacy and Data Protection
                        </h2>
                        <p>
                            We take your privacy seriously. Your financial data is:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Stored securely</li>
                            <li>Never shared with third parties without your explicit consent</li>
                            <li>Used solely for providing the budgeting service</li>
                            <li>Accessible only to you and family members you explicitly authorize</li>
                        </ul>
                        <p style={{ marginTop: '12px' }}>
                            You retain full ownership of your data and may request its deletion at any time by contacting support.
                        </p>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            5. Acceptable Use
                        </h2>
                        <p>
                            You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Use the Service for any illegal or unauthorized purpose</li>
                            <li>Attempt to gain unauthorized access to other users' accounts or data</li>
                            <li>Upload malicious code or attempt to disrupt the Service</li>
                            <li>Use the Service to store or transmit illegal content</li>
                            <li>Violate any applicable local, state, national, or international law</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            6. Service Availability
                        </h2>
                        <p>
                            While we strive to maintain high availability, we do not guarantee that the Service will be available 100% of the time. The Service may be temporarily unavailable due to:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Scheduled maintenance</li>
                            <li>Technical difficulties</li>
                            <li>Third-party service disruptions</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            7. Limitation of Liability
                        </h2>
                        <p>
                            The Service is provided "as is" without warranties of any kind. We shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Use or inability to use the Service</li>
                            <li>Loss of data or financial information</li>
                            <li>Unauthorized access to your account</li>
                            <li>Errors or omissions in the Service</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            8. Data Backup and Recovery
                        </h2>
                        <p>
                            While we implement regular backup procedures, you are encouraged to maintain your own records of important financial data. We recommend regularly exporting your data for your own records.
                        </p>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            9. Termination
                        </h2>
                        <p>
                            Either party may terminate this agreement at any time. Upon termination:
                        </p>
                        <ul style={{ paddingLeft: '24px', marginTop: '12px' }}>
                            <li>Your access to the Service will be immediately suspended</li>
                            <li>You may request a final export of your data within 30 days</li>
                            <li>Your data will be permanently deleted after 90 days unless otherwise requested</li>
                        </ul>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            10. Changes to Terms
                        </h2>
                        <p>
                            We reserve the right to modify these terms at any time. Users will be notified of significant changes via email or through the application. Continued use of the Service after changes constitutes acceptance of the new terms.
                        </p>
                    </section>

                    <section style={{ marginBottom: '32px' }}>
                        <h2 style={{ color: '#ff6b35', fontSize: '1.5rem', marginBottom: '16px' }}>
                            11. Contact Information
                        </h2>
                        <p>
                            If you have any questions about these Terms and Conditions, please contact us at:
                        </p>
                        <div style={{
                            background: 'rgba(255, 107, 53, 0.1)',
                            border: '1px solid rgba(255, 107, 53, 0.3)',
                            borderRadius: '8px',
                            padding: '16px',
                            marginTop: '12px'
                        }}>
                            <p style={{ margin: '0' }}>
                                <strong>Email:</strong> info@duttonbiz.com<br />
                            </p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default TermsAndConditions;